class Control {
	constructor() {
		if (this) {
			const that = this as any
			that.isCalled = false
			that.timeout = null
		}
	}

	isCalled: boolean | null = null
	timeout: any | null = null

	throttle(fn: Function, wait: number) {
		return (...args) => {
			if (!this.isCalled) {
				fn(...args)

				this.isCalled = true

				setTimeout(() => {
					this.isCalled = false
				}, wait)
			}
		}
	}

	debounce(func: Function, wait = 100, immediate?: boolean) {
		return (...args: any[]) => {
			const later = () => {
				this.timeout = null

				if (!immediate) {
					func(...args)
				}
			}

			const callNow = immediate && !this.timeout
			clearTimeout(this.timeout)
			this.timeout = setTimeout(later, wait)

			if (callNow) {
				func(...args)
			}
		}
	}
}

export default Control
